async function updateFloatingCartCounter() {
  try {
    const res = await fetch("/cart.js");
    const cart = await res.json();
    const counterEl = document.getElementById("CartCounterBubble");

    if (!counterEl) return;

    const count = cart.item_count;

    counterEl.textContent = count > 0 ? String(count) : "";
    counterEl.style.opacity = "";
    if (count >= 10) {
      counterEl.setAttribute("data-cart-wide", "");
    } else {
      counterEl.removeAttribute("data-cart-wide");
    }
  } catch (err) {
    console.error("Counter error:", err);
  }
}

function initPdpFloatingCartCounter() {
  updateFloatingCartCounter();
  setInterval(updateFloatingCartCounter, 2500);

  if (typeof subscribe === "function") {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => updateFloatingCartCounter());
  }
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initPdpFloatingCartCounter);
} else {
  initPdpFloatingCartCounter();
}
